import { render, staticRenderFns } from "./ReceptionDashboard.vue?vue&type=template&id=40e21b60&"
import script from "./ReceptionDashboard.vue?vue&type=script&lang=js&"
export * from "./ReceptionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports